import { extend, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import enLocale from 'vee-validate/dist/locale/en.json'
import deLocale from 'vee-validate/dist/locale/de.json'
import esLocale from 'vee-validate/dist/locale/es.json'
import frLocale from 'vee-validate/dist/locale/fr.json'
import huLocale from 'vee-validate/dist/locale/hu.json'
import itLocale from 'vee-validate/dist/locale/it.json'
import nlLocale from 'vee-validate/dist/locale/nl.json'
import ruLocale from 'vee-validate/dist/locale/ru.json'

const VeeValidateLocales = {
	en: enLocale,
	de: deLocale,
	es: esLocale,
	fr: frLocale,
	hu: huLocale,
	it: itLocale,
	nl: nlLocale,
	ru: ruLocale
}

export function loadLocale (i18n, code) {
	const languageCode = VeeValidateLocales[code] ? code : 'en'
	const locale = VeeValidateLocales[languageCode]

	localize(languageCode, locale.messages)

	const fieldLocalizeObj = {}
	const names = {
		email: i18n.tc('veeValidate.email'),
		password: i18n.tc('veeValidate.password'),
		'team name': i18n.tc('veeValidate.teamName'),
		name: i18n.tc('veeValidate.name'),
		'password-repeat': i18n.tc('veeValidate.passwordRepeat'),
		'club name': i18n.tc('veeValidate.clubName'),
		'sport type': i18n.tc('veeValidate.sportType'),
		'team short name': i18n.tc('veeValidate.teamShortName'),
		'team Website': i18n.tc('veeValidate.teamWebsite'),
		city: i18n.tc('veeValidate.city'),
		state: i18n.tc('veeValidate.state'),
		postcode: i18n.tc('veeValidate.postcode'),
		phone: i18n.tc('veeValidate.phone'),
		reference: i18n.tc('veeValidate.reference'),
		role: i18n.tc('veeValidate.role'),
		gender: i18n.tc('veeValidate.gender'),
		zipcode: i18n.tc('veeValidate.zipcode'),
		player: i18n.tc('veeValidate.player'),
		title: i18n.tc('veeValidate.title'),
		'clip name': i18n.tc('veeValidate.clipName')
	}

	fieldLocalizeObj[code] = { names }
	localize(fieldLocalizeObj)
}

export default ({ app, $log }) => {
	Object.keys(rules).forEach(rule =>
		extend(rule, {
			// eslint-disable-next-line import/namespace
			...rules[rule]
		})
	)

	extend('isValidPhone', {
		params: ['isValid'],
		message: field => app.i18n.t('errors.invalidPhone'),
		validate: (value, { isValid }) => (value ? isValid : true)
	})

	loadLocale(app.i18n, app.i18n.locale)
}
